import { createFileRoute } from '@tanstack/react-router';
import LazyRoute from '../components/LazyRoute';
import { TablePageLoader } from '@/components/ui/page-loader';

export const Route = createFileRoute('/_protected/sources/')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/pages/Sources')}
      fallback={<TablePageLoader />}
    />
  ),
});
